import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import RanchAPI from "../api/Ranch.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { Ranch, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Ranch>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(ranch: Ranch): JSX.Element[] {
  return [
    <TableCell key={"name"}>{ranch.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(ranch.createdAt)}</TableCell>,
  ];
}

export default function RanchList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Ranches</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={RanchAPI.useList}
          modelBaseUrl={"ranches"}
          columns={columns}
          buildTableRow={buildTableRow}
        />

        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={RanchAPI.useSave}
          navigateUrl="/ranches"
        />
      </Box>
    </Layout>
  );
}
